import React from 'react'

const Footer = () => {
  return (
    <footer className='fixed bottom-0 left-0 right-0 bg-gray-900 z-40 shadow-lg'>
        <div className='px-4 sm:px-6 lg:px-16 py-3'>
            <p className='text-slate-50 text-sm text-center'>
                &copy; 2025 Oodles Internships. All rights reserved.
            </p>
        </div>
    </footer>
  )
}

export default Footer